"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addKeyValue = exports.mapObjToString = exports.mapGeneralObjToString = exports.transformToICalKey = exports.foldLine = exports.parseNewLine = void 0;
var common_1 = require("../../common");
var parseNewLine = function (value) {
    return value ? value.replaceAll('\n', '\\n') : '';
};
exports.parseNewLine = parseNewLine;
var parseWithEmptySpace = function (text, index) {
    if (index === 0) {
        return text;
    }
    if (text.slice(0, 1) !== ' ') {
        return " ".concat(text);
    }
    return text;
};
var splitByMaxLength = function (text) {
    var result = [];
    var reminder = text;
    var index = 0;
    while (reminder.length > 0) {
        if (reminder.length + 1 < common_1.MAX_LINE_LENGTH) {
            result.push("".concat(parseWithEmptySpace(reminder, index)));
            reminder = '';
        }
        else {
            result.push("".concat(parseWithEmptySpace(reminder, index).slice(0, common_1.MAX_LINE_LENGTH - 1)));
            // handle shift because of added empty space
            if (index > 0) {
                reminder = reminder.slice(common_1.MAX_LINE_LENGTH - 2);
            }
            else {
                reminder = reminder.slice(common_1.MAX_LINE_LENGTH - 1);
            }
        }
        index++;
    }
    return result;
};
var splitToRows = function (text) {
    var result = '';
    var textArray = text.split('\n');
    var index = 0;
    var reminder = '';
    for (var _i = 0, textArray_1 = textArray; _i < textArray_1.length; _i++) {
        var item = textArray_1[_i];
        var parsedItem = index === 0 ? item : " ".concat(item);
        if (parsedItem.length === common_1.MAX_LINE_LENGTH) {
            result += parsedItem + (index + 1 < textArray.length ? '\n' : '');
            reminder = '';
        }
        else if (parsedItem.length > common_1.MAX_LINE_LENGTH) {
            var subArray = splitByMaxLength(parsedItem);
            var subIndex = 0;
            for (var _a = 0, subArray_1 = subArray; _a < subArray_1.length; _a++) {
                var subItem = subArray_1[_a];
                result +=
                    subItem +
                        (index + 1 < textArray.length || subIndex + 1 < subArray.length
                            ? '\n'
                            : '');
                subIndex++;
            }
            reminder = '';
        }
        else {
            result += parsedItem + (index + 1 < textArray.length ? '\n' : '');
            reminder = '';
        }
        index += 1;
    }
    if (reminder) {
        result += reminder;
    }
    return result;
};
var foldLine = function (row, oldWay) {
    var result = '';
    var foldCount = row.length / common_1.MAX_LINE_LENGTH;
    var tempRow = row;
    if (!oldWay) {
        return splitToRows(row);
    }
    if (row.length < common_1.MAX_LINE_LENGTH) {
        return row;
    }
    for (var i = 1; i <= foldCount + 1; i += 1) {
        if (tempRow.length <= common_1.MAX_LINE_LENGTH) {
            result = result + tempRow;
            return result;
        }
        else {
            result = result + tempRow.slice(0, common_1.MAX_LINE_LENGTH) + '\n ';
            var newTempRow = tempRow.slice(i * common_1.MAX_LINE_LENGTH);
            if (!newTempRow) {
                tempRow = tempRow.slice(common_1.MAX_LINE_LENGTH);
            }
            else {
                tempRow = tempRow.slice(i * common_1.MAX_LINE_LENGTH);
            }
        }
    }
    return result;
};
exports.foldLine = foldLine;
var transformToICalKey = function (key) {
    var result = '';
    for (var i = 0; i < key.length; i += 1) {
        var letter = key[i];
        // Transform camel case to dash
        if (letter.toUpperCase() === letter) {
            result += "-".concat(letter);
        }
        else {
            result += letter.toUpperCase();
        }
    }
    return result;
};
exports.transformToICalKey = transformToICalKey;
var mapGeneralObjToString = function (obj) {
    var result = '';
    for (var _i = 0, _a = Object.entries(obj); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        result = result + key.toUpperCase() + '=' + value + ';';
    }
    var endingNeedsSlice = result.slice(result.length - 1, result.length) === ';';
    return endingNeedsSlice ? result.slice(0, result.length - 1) : result;
};
exports.mapGeneralObjToString = mapGeneralObjToString;
var mapObjToString = function (obj) {
    var result = '';
    var mailtoValue = ':mailto:';
    for (var _i = 0, _a = Object.entries(obj); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (key !== 'mailto') {
            result = result + key.toUpperCase() + '=' + value + ';';
        }
        else {
            mailtoValue = mailtoValue + value;
        }
    }
    var endingNeedsSlice = result.slice(result.length - 1, result.length) === ';';
    return ((endingNeedsSlice ? result.slice(0, result.length - 1) : result) +
        mailtoValue);
};
exports.mapObjToString = mapObjToString;
var addKeyValue = function (iCalString, key, value) { return "".concat(iCalString).concat(key).concat(value, "\n"); };
exports.addKeyValue = addKeyValue;
